var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6 col-xl-4"},[_c('div',{staticClass:"no-user-card"},[_c('div',{staticClass:"no-user-image",on:{"click":_vm.showInviteModal}},[(_vm.loggedInUser.role == 1)?_c('span',[_vm._v("+")]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }